import { Navigate, useSearchParams } from 'react-router-dom';
import { match, P } from 'ts-pattern';
import { useWidgetRef } from '~/hooks/widgetHooks';
import { InsightStatusCard } from './CustomerInsight';

export default function DefaultIntegrationNavigation() {
  const widgetRef = useWidgetRef();
  const [searchParams] = useSearchParams();

  return match(widgetRef)
    .with('corso-concierge', () => (
      // ideally should never be displayed, as within this scope, it should ideally automatically redirect to a specific claim
      <InsightStatusCard
        title="Claim Not Detected"
        detail="Reload to try again, or search for anything."
        icon="info"
      />
    ))
    .with(P.union('kustomer', 'zendesk'), () => (
      <Navigate
        to={{
          pathname: 'customer',
          search: searchParams.toString(),
        }}
        replace
      />
    ))
    .with(null, () => {
      // unexpected given structural routing, and should never happen; logged and recovered with redirect to root
      console.error(
        `Loaded ${DefaultIntegrationNavigation.name} with null widgetRef`,
      );

      return (
        <Navigate
          to={{
            pathname: '/',
            search: searchParams.toString(),
          }}
          replace
        />
      );
    })
    .exhaustive();
}
